/* import __COLOCATED_TEMPLATE__ from './jp-smirf-enrollment.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { getFormattedSmirfCpRate, JpSmirfState } from '@dashboard/shared-ui/utils/jp-smirf';
import { inject as service } from '@ember/service';
let JpSmirfEnrollmentComponent = (_class = class JpSmirfEnrollmentComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "State", JpSmirfState);
    // expose State to the hbs template
    _initializerDefineProperty(this, "state", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    if (this.args.hasError || !this.args.getMerchantStatusResponse) {
      this.state = JpSmirfState.SERVER_ERROR;
      return;
    }
    if (!this.args.getMerchantStatusResponse.isSmirfFormSubmitted) {
      if (this.args.getMerchantStatusResponse.isEligible) {
        this.state = JpSmirfState.ENROLLMENT_FORM;
      } else {
        this.state = JpSmirfState.INELIGIBLE;
      }
    } else {
      if (this.args.getMerchantStatusResponse.isOptedIn) {
        if (this.args.getMerchantStatusResponse.smirfSqRateEnabled) {
          this.state = JpSmirfState.ENROLLMENT_SUCCESS;
        } else {
          this.state = JpSmirfState.ENROLLMENT_NO_LONGER_ELIGIBLE;
        }
      } else {
        this.state = JpSmirfState.ENROLLMENT_FAILURE;
      }
    }
  }
  setState(newState) {
    this.state = newState;
  }
  onSubmitForm(success) {
    if (success) {
      this.setState(JpSmirfState.ENROLLMENT_SUCCESS);
    } else {
      this.setState(JpSmirfState.ENROLLMENT_FAILURE);
    }
  }
  get formattedSmirfCpRate() {
    return getFormattedSmirfCpRate(this.intl, this.args.getRegistrationInfoResponse);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "state", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSubmitForm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmitForm"), _class.prototype), _class);
export { JpSmirfEnrollmentComponent as default };